import {formater} from '../formater/formater';

$(document).ready(function(){
 
  var format = new formater();
  var $phone = $('#profile_phone_number');
  
  if ($phone .value !== "" && $phone .value !== "undefined" ){
    var fone = document.getElementById('profile_phone_number');  
    $phone .keyup(function(){
      fone.value= format.applyMasc(fone.value,'tel') 
    });
    $phone .focusout(function(){
      fone.value= format.applyMasc(fone.value,'tel') 
    });        
  };

});